module.exports = __webpack_public_path__ + "img/gauge-min.cdc4ec1e.svg";